import {SkeletonBox, SkeletonText} from '@primer/react/experimental'
import styles from './TimelinePanel.module.css'

function TimelineEventSkeletonRow() {
  return (
    <div className={styles.skeletonRow}>
      <SkeletonBox className={styles.skeletonBadge} />
      <SkeletonText size="bodySmall" className={styles.skeletonText} />
    </div>
  )
}

export function TimelinePanelSkeleton({count = 5}: {count?: number}) {
  return (
    <div role="status" className={styles.skeletonContainer}>
      {Array.from({length: count}, (_, i) => (
        <TimelineEventSkeletonRow key={i} />
      ))}
    </div>
  )
}
